import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import SideBar from "../../SideBar";
import HeaderName from "../../HeaderName";
import { useSelector } from "react-redux";
import { API_URL } from "../../../../api";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

//const uri = 'http://localhost:9000/api/';

export default function StockList() {
  const [stockList, setStockList] = useState([]);
  const [metaData, setMetaData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [itemList, setItemList] = useState([]);
  const [items, setItems] = useState([]);
  const [uri, setUri] = useState("");
  const [show, setShow] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPage, setTotalPage] = useState(0);

  // const [page, setPage] = useState(1);
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  const finalFilter = (event) => {
    let data = {
      searchId: event.target.value,
    };
    api
      .get("logs", { params: data })
      .then((response) => {
        console.log(response);
        // setTodayList([])
        setStockList(response?.data?.data);

        setMetaData(response?.data?._metadata);
        console.log(metaData);
      })
      .catch((error) => {
        Swal.fire({
          title: "404",
          text: error.response?.data.message,
          icon: "warning",
          confirmButtonText: "CANCEL",
        });
      });
    // const filteredArray = stockList.filter(obj => [obj.relatedProcedureItems?._id, obj.relatedAccessoryItems?._id, obj.relatedMachine?._id].includes(event.target.value));
    // console.log(filteredArray,'filterdarray')
    // setStockList(filteredArray)
  };

  const handleItems = (event) => {
    if (uri === "false") {
      setShow(false);
      let data = {
        id: event,
      };
      api
        .get("logs/filter", { params: data })
        .then((response) => {
          // setTodayList([])
          setStockList(response?.data?.data);
          setMetaData(response?.data?._metadata);
          console.log(metaData);
        })
        .catch((error) => {
          Swal.fire({
            title: "404",
            text: error.response?.data.message,
            icon: "warning",
            confirmButtonText: "CANCEL",
          });
        });
    } else {
      setShow(true);
      api
        .get(uri + "/" + event)
        .then((response) => {
          // setTodayList([])
          setItems(response?.data?.data);
        })
        .catch((error) => {
          Swal.fire({
            title: "Error",
            text: error.response?.data.message,
            icon: "error",
            confirmButtonText: "CANCEL",
          });
        });
    }
  };

  const handleCategory = (event) => {
    switch (event) {
      case "Machine": {
        handleMachine();
        setUri("false");
        setShow(true);
        break;
      }
      case "Medicine": {
        handleMedicine();
        setUri("medicine-items");
        break;
      }
      case "Procedure Medicine": {
        handleProcedureMedicine();
        setUri("procedure-items");
        break;
      }
      case "Procedure Accessory": {
        handleProcedureAccessory();
        setUri("accessory-items");
        break;
      }
      default:
        return event;
    }
  };

  const handleMachine = (event) => {
    api
      .get("fixed-assets")
      .then((response) => {
        // setTodayList([])
        setItemList(response?.data.list);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response?.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  const handleMedicine = (event) => {
    api
      .get("medicine-lists")
      .then((response) => {
        // setTodayList([])
        setItemList(response?.data.list);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response?.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };
  const handleProcedureMedicine = (event) => {
    api
      .get("procedure-medicines")
      .then((response) => {
        // setTodayList([])
        setItemList(response?.data.list);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response?.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };
  const handleProcedureAccessory = (event) => {
    api
      .get("procedure-accessories")
      .then((response) => {
        // setTodayList([])
        setItemList(response?.data.list);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response?.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  console.log(itemList);

  const handleUsage = (event) => {
    console.log(event);
    let data = {
      type: event,
    };
    api
      .get("logs", { params: data })
      .then((response) => {
        console.log(response);
        // setTodayList([])
        setStockList(response?.data?.data || []);
        setMetaData(response?.data?._metadata);
        console.log(metaData);
      })
      .catch((error) => {
        Swal.fire({
          title: "404",
          text: error.response?.data.message,
          icon: "warning",
          confirmButtonText: "CANCEL",
        });
      });
    // const filteredArray = stockList.filter(obj => [obj.relatedProcedureItems?._id, obj.relatedAccessoryItems?._id, obj.relatedMachine?._id].includes(event.target.value));
    // console.log(filteredArray,'filterdarray')
    // setStockList(filteredArray)
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const filter = (event) => {
    // console.log(endDate);
    // const nDate = new Date(endDate);
    // console.log(nDate);
    // const toDate = nDate.setDate(nDate.getDate() + 1);
    // console.log(toDate);

    let data = {
      start: startDate,
      end: endDate,
    };
    api
      .get("logs", { params: data })
      .then((response) => {
        // setTodayList([])
        setStockList(response?.data?.data);
        setMetaData(response?.data?._metadata);
        console.log(metaData);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response?.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  useEffect(() => {
    const getStockLogList = async (page) => {
      api
        .get(`logs?page=${page}&limit=${rowsPerPage}`)
        .then((response) => {
          setStockList(response?.data?.data);
          setCurrentPage(response?.data?._metadata.currentPage);
          setTotalPage(response?.data?._metadata.totalPage);
          const metadata = response?.data?._metadata;
          console.log(metadata);
          setMetaData(metadata);
          console.log(response?.data?.data);
          console.log(currentPage);
          console.log(totalPage);

          // const totalLogList = response?.data?.count;
        })
        .catch((error) => {
          Swal.fire({
            title: "Error",
            text: error.response?.data.message,
            icon: "error",
            confirmButtonText: "CANCEL",
          });
        });
    };

    getStockLogList(currentPage);
  }, [currentPage, rowsPerPage]);

  return (
    <div classNameName="App">
      {/* <!-- end preloader --> */}
      {/* @include('sweet::alert') */}

      <div className="wrapper">
        <div style={{ paddingBottom: "1.5rem" }}>
          {/* <!-- Content Header (Page header) --> */}
          <div className="content-header">
            <div className="container-fluid px-2">
              <div className="row mb-2">
                <div className="col-sm-12"></div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8">
              <div className="row ml-2">
                <div className="form-group col-md-3">
                  <label>From</label>
                  <input
                    type="date"
                    name="from"
                    id="from"
                    className="form-control"
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </div>
                <div className="form-group col-md-3">
                  <label>To</label>
                  <input
                    type="date"
                    name="to"
                    id="to"
                    className="form-control"
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>
                <div className="form-group col-md-2">
                  <button
                    className="btn btn-sm btn-primary form-control"
                    style={{ marginTop: "33px" }}
                    onClick={filter}
                  >
                    Filter
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- Main content --> */}
          <div className="row px-4">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <div className="row">
                    <div className="row col-6">
                      <div className="form-group col-md-2">
                        <h2 className="card-title mt-3">
                          <b>Log List</b>
                        </h2>
                      </div>
                      <div className="form-group col-md-3 mt-2">
                        <select
                          class="custom-select border-info"
                          onChange={(e) => {
                            handleCategory(e.target.value);
                          }}
                        >
                          <option>Choose Category</option>
                          <option value="Machine">Machine</option>
                          <option value="Medicine">Medicine</option>
                          <option value="Procedure Medicine">
                            Procedure Medicine
                          </option>
                          <option value="Procedure Accessory">
                            Procedure Accessory
                          </option>
                        </select>
                      </div>

                      <div className="form-group col-md-3 mt-2">
                        <select
                          class="custom-select border-info"
                          disabled={itemList.length === 0}
                          onChange={(e) => handleItems(e.target.value)}
                        >
                          <option>Choose Item List</option>
                          {itemList.map((element, index) => (
                            <option value={element._id}>{element.name}</option>
                          ))}
                        </select>
                      </div>
                      {show ? (
                        <div className="form-group col-md-3 mt-2">
                          <select
                            class="custom-select border-info"
                            disabled={items.length === 0}
                            onChange={(e) => finalFilter(e)}
                          >
                            <option>Choose Items</option>
                            {items.map((element, index) => (
                              <option value={element._id}>
                                {element.procedureItemName
                                  ? element.procedureItemName
                                  : element.medicineItemName
                                    ? element.medicineItemName
                                    : element.accessoryItemName}
                              </option>
                            ))}
                          </select>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="row col-4">
                      <div className="form-group col-md-2">
                        <h2 className="card-title mt-3">
                          <b>Type</b>
                        </h2>
                      </div>
                      <div className="form-group col-md-10 mt-2">
                        <select
                          class="custom-select border-info"
                          onChange={(e) => {
                            handleUsage(e.target.value);
                          }}
                        >
                          <option>Choose Type</option>
                          <option value="Medicine Sale">Medicine Sale</option>
                          <option value="Treatment Usage">
                            Treatment Usage
                          </option>
                          <option value="Stock Update">Stock Update</option>
                          <option value="Purchase">Purchase</option>
                        </select>
                      </div>
                    </div>
                    <div className="row col-2">
                      <div className="form-group col-12 mt-2">
                        <select
                          id="options"
                          className="mb-3 p-2 form-select w-50"
                          value={rowsPerPage}
                          onChange={(e) => setRowsPerPage(e.target.value)}
                        >
                          <option value="10">10</option>
                          <option value="20">20</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <span className="">
                    {metaData.count === 0 ? (
                      <>Showing 0 of 0</>
                    ) : (
                      <>
                        Showing {(currentPage - 1) * rowsPerPage + 1}
                        {" - "}
                        {Math.min(
                          currentPage * rowsPerPage,
                          metaData.totalItems,
                        )}
                        {" of "}
                        <strong>{metaData.totalPage}</strong>
                        {" rows "}
                      </>
                    )}
                  </span>
                </div>

                <div className="card-body">
                  <table id="example1" className="table">
                    <thead className=" bg-info">
                      <tr>
                        <th>No</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Voucher Code</th>
                        <th>Item</th>
                        {/* <th>Related Treatment</th> */}
                        <th>Treatment Selection</th>
                        <th>Appointment</th>
                        <th>Current QTY</th>
                        <th>Actual QTY</th>
                        <th>Final QTY</th>
                        <th className="text-center">Action</th>
                      </tr>
                    </thead>
                    <>
                      {stockList.map((e, i) => (
                        <tbody key={e._id}>
                          <tr>
                            <td>
                              {((Number(currentPage) || 1) - 1) * rowsPerPage +
                                i +
                                1}
                            </td>
                            <td>{e.date?.split("T")[0] || "-"}</td>
                            <td>
                              {e.date
                                ? new Date(e.date).toLocaleTimeString([], {
                                    hour: "numeric",
                                    minute: "2-digit",
                                    hour12: true,
                                  })
                                : "-"}
                            </td>
                            <td>{e.relatedTreatmentVoucher?.code || "-"}</td>
                            <td className="">
                              {/* {e.relatedProcedureItems?.procedureItemName ||
                                e.relatedAccessoryItems?.accessoryItemName ||
                                e.relatedMachine?.name} */}
                              <span>{e.relatedMedicineItems?.code || "-"}</span>
                              <p>
                                {e.relatedMedicineItems?.medicineItemName ||
                                  "-"}
                              </p>
                            </td>
                            <td>
                              {e.relatedTreatmentSelection?.relatedTreatment
                                ?.name || "-"}
                            </td>
                            <td>
                              {e.relatedAppointment?.originalDate?.split(
                                "T",
                              )[0] || "-"}
                            </td>
                            <td>{e.currentQty ? e.currentQty : "-"}</td>
                            <td>{e.actualQty ? e.actualQty : "-"}</td>
                            <td>{e.finalQty ? e.finalQty : "-"}</td>
                            <td className="text-center">
                              <button class="btn btn-primary btn-sm">
                                Related
                              </button>
                            </td>
                          </tr>

                          <tr
                            className="bg-gradient-light"
                            id={"toggle" + e._id}
                            hidden
                          >
                            <td colspan="12">
                              <div>
                                <div class="row">
                                  <div class="col-md-2">
                                    <label
                                      style={{ fontSize: "15px" }}
                                      class="text-dark"
                                    >
                                      No
                                    </label>
                                  </div>
                                  <div class="col-md-3">
                                    <label
                                      style={{ fontSize: "15px" }}
                                      class="text-dark"
                                    >
                                      Account
                                    </label>
                                  </div>
                                  <div class="col-md-2">
                                    <label
                                      style={{ fontSize: "15px" }}
                                      class="text-dark"
                                    >
                                      Type
                                    </label>
                                  </div>
                                  <div class="col-md-2">
                                    <label
                                      style={{ fontSize: "15px" }}
                                      class="text-dark"
                                    >
                                      Date
                                    </label>
                                  </div>
                                  <div class="col-md-2">
                                    <label
                                      style={{ fontSize: "15px" }}
                                      class="text-dark"
                                    >
                                      Amount
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      ))}
                    </>
                  </table>
                </div>
              </div>
              <div className="d-flex justify-content-center py-3">
                <Stack spacing={2}>
                  <Pagination
                    count={totalPage}
                    page={currentPage}
                    onChange={handlePageChange}
                  />
                </Stack>
              </div>
            </div>
          </div>
          {/* <MedicineSaleDialog
            open={open}
            close={() => setOpen(false)}
            setOpen={setOpen}
            grand={grand}
          /> */}
        </div>

        {/* <!-- /.content-wrapper --> */}

        {/* <!-- Control Sidebar --> */}
        <aside className="control-sidebar control-sidebar-dark">
          {/* <!-- Control sidebar content goes here --> */}
        </aside>
        {/* <!-- /.control-sidebar --> */}
      </div>
      {/* <!-- ./wrapper --> */}
    </div>
  );
}
